import {
  RandomForestClassifier,
  RandomForestRegression,
} from "ml-random-forest";
import { ALL_MODELS, DATA_TYPES, MODEL_STATES } from "../constants";
import { argMax } from "../helpers/DataHelpers";
import { frequencyCounts } from "../helpers/FrequencyCounts";
import { stateTypeF } from "../state";
import { BaseModel } from "./BaseModel";
import { dataSplit, infoType } from "./Dataset";

export class RandomForest extends BaseModel {
  modelName = ALL_MODELS.randomForest;
  maxElements = 50000;

  model: RandomForestRegression | RandomForestClassifier;
  modelState = MODEL_STATES.ready;

  constructor(mlDataInfo: infoType) {
    super(mlDataInfo);
  }

  async train(
    trainData: dataSplit,
    state: stateTypeF,
    callbackFunction: Function
  ) {
    if (this.mlDataInfo.outputType == DATA_TYPES.number) {
      const options = {
        seed: 3,
        maxFeatures: Math.min(trainData.X[0].length, 5),
        replacement: true,
        nEstimators: 100,
      };
      this.model = new RandomForestRegression(options);
    } else if (this.mlDataInfo.outputType == DATA_TYPES.categorical) {
      const options = {
        seed: 3,
        maxFeatures: Math.min(trainData.X[0].length, 10),
        replacement: true,
        nEstimators: 200,
      };
      this.model = new RandomForestClassifier(options);
    }

    this.model.train(trainData.xTrain, trainData.yTrain, callbackFunction);
    this.isBestModel(trainData.xTest, trainData.yTest);
  }

  predict(X: number[][]) {
    var output: number[];
    if (this.mlDataInfo.outputType == DATA_TYPES.categorical) {
      const probs = this.predictProbs(X);
      output = new Array(probs.length);
      for (let i = 0; i < probs.length; ++i) {
        output[i] = argMax(probs[i]);
      }
    } else if (this.mlDataInfo.outputType == DATA_TYPES.number) {
      output = this.model.predict(X);
    }
    return output;
  }

  predictProbs(X: number[][]) {
    const predictionValues = this.model.predictionValues(X);
    let probs: number[][] = [];
    for (let i = 0; i < predictionValues.rows; i++) {
      let row = predictionValues.getRow(i);
      let freqCounts = frequencyCounts(row);
      let total = 0;
      let rowProbs: number[] = Array(this.mlDataInfo.outputShape).fill(0);
      for (const [key, value] of Object.entries(freqCounts)) {
        rowProbs[Number(key)] = value;
        total += value;
      }
      probs.push(rowProbs.map((val) => val / total));
    }
    return probs;
  }
}
